
import Additem from "../../../assets/duotone/Additem.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AdditemIcon({ className, dataTestid = "AdditemIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Additem data-testid={dataTestid} className={classes} {...rest} />
  );
}
